import { Box3, Object3D, Points, Ray, Vector3 } from 'three';

import { ProgressController } from '../../../../../../react/utils/progress-controller';
import { PromiseAbortController } from '../../../../../../react/utils/promise-abort-controller';
import { isDefined } from '../../../../../../utils/variables';
import { PointCloud } from '../../../../../geodata/point-clouds/types';

export async function loadHighResolutionLodPointCloudChunksFromRays(
  rays: Ray[],
  progressController: ProgressController,
  abortController: PromiseAbortController,
  activePointCloud: PointCloud,
): Promise<{ parent: Object3D; points: Points[] }> {
  const chunks = new Object3D();
  const points: Points[] = [];

  chunks.position.copy(activePointCloud.position);

  points.push(
    ...(await activePointCloud.getMaxLodChunksFromRays(
      rays,
      abortController.signal,
      progressController,
    )),
  );

  chunks.add(...points.filter((x) => !isDefined(x.parent)));

  return { parent: chunks, points: points };
}

export async function loadHighResolutionLodPointCloudChunks(
  vertices: Vector3[],
  progressController: ProgressController,
  abortController: PromiseAbortController,
  activePointCloud: PointCloud,
): Promise<{ parent: Object3D; points: Points[] }> {
  const bbox = new Box3().setFromPoints(vertices);
  bbox.min.z = Number.MIN_SAFE_INTEGER;
  bbox.max.z = Number.MAX_SAFE_INTEGER;

  const chunks = new Object3D();
  const points: Points[] = [];

  chunks.position.copy(activePointCloud.position);

  points.push(
    ...(await activePointCloud.getMaxLodChunksWithinBoundingBox(
      bbox,
      abortController.signal,
      progressController,
    )),
  );

  chunks.add(...points.filter((x) => !isDefined(x.parent)));

  return { parent: chunks, points: points };
}
